export default "__VITE_ASSET__BhbflO8T__"